import { Injectable, inject } from '@angular/core';
import { BillsV4Service } from '../../zentility/_shared/_services/v4/bills-v4.service';
import { ZenDialogMsgService } from '../../zentility/_shared/_services/zen-dialog-msg.service';
import { PhysicalBillType } from '../../zentility/_shared/_model/bills-v4.model';
import { ExistingFileType } from '../models/bill-import.models';
import { ExistingBillRef } from '../components/bill-ai-flow/state/bill-ai-flow.models';

/** Opens an already-imported bill's stored PDF in a new browser tab. */
@Injectable({ providedIn: 'root' })
export class ExistingBillPdfService {
  private readonly bills = inject(BillsV4Service);
  private readonly toast = inject(ZenDialogMsgService);

  open(ref: ExistingBillRef | null, billId: number, fileType: ExistingFileType): void {
    if (!ref) {
      console.error('[ExistingBillPdfService] No customer, address or meter for bill', billId);
      this.toast.openToast(false, "Could not open the bill PDF because its meter isn't resolved yet.");
      return;
    }
    const slot = fileType === 'SUPPLIER' ? PhysicalBillType.SUPPLIER : PhysicalBillType.UTILITY;
    this.bills.previewBillFileByType(ref.commodityType, ref.customerId, ref.serviceAddressId, ref.meterId, billId, slot)
      .catch(err => {
        console.error('[ExistingBillPdfService] Opening the PDF failed', billId, fileType, err);
        this.toast.openToast(false, 'Could not open the bill PDF. The file may be missing.');
      });
  }
}
